module.exports = __webpack_public_path__ + "static/media/privacy-back.7153080f.png";